import React from 'react';
import {
  ClaimsTagIcon,
  Contract,
  InformationIcon,
  OperationIcon2,
  SuggestedTaskIcon,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

export interface TagProperties {
  tagColor: string;
  tagIcons: React.JSX.Element;
  insightsTitle: string;
  cardTitleColor: string;
  cardStyle?: React.CSSProperties;
  cardIcon?: React.JSX.Element;
}

export const getTagProperties = (tag: string): TagProperties => {
  switch (tag.toLowerCase()) {
    case 'contract aiq':
      return {
        tagColor: '#934EFB',
        tagIcons: (
          <Contract
            style={{
              color: '#934EFB',
              transform: 'scaleX(-1)',
              transformOrigin: 'center center',
            }}
          />
        ),
        insightsTitle: 'Insight discovered',
        cardTitleColor: '#17A39C',
        cardStyle: {
          backgroundColor: '#08C7B41A',
          borderColor: '#08C7B440',
          gap: '8px',
        },
        cardIcon: (
          <InformationIcon width="16px" height="16px" fillColor="#17A39C" />
        ),
      };
    case 'claims aiq':
      return {
        tagColor: '#08C7B4',
        tagIcons: <ClaimsTagIcon />,
        insightsTitle: 'Insight discovered',
        cardTitleColor: '#17A39C',
        cardStyle: {
          backgroundColor: '#08C7B41A',
          borderColor: '#08C7B440',
          gap: '8px',
        },
        cardIcon: (
          <InformationIcon width="15px" height="15px" fillColor="#17A39C" />
        ),
      };
    case 'operations':
      return {
        tagColor: '#F2763D',
        tagIcons: <OperationIcon2 />,
        insightsTitle: 'Suggested Task',
        cardTitleColor: '#E08083',
        cardStyle: {
          backgroundColor: '#F5A4A533',
          borderColor: '#EDC0BB',
          gap: '8px',
        },
        cardIcon: <SuggestedTaskIcon />,
      };
    default:
      return {
        tagColor: '#000000',
        tagIcons: <span></span>,
        insightsTitle: '',
        cardTitleColor: '#17A39C',
      };
  }
};
